import React from 'react';
import PropTypes from 'prop-types';
import FormSection from '../FormSection';

const FormTableSection = ({ columns, ...rest }) => {
  return (
    <tr className="section-row">
      <td colSpan={columns}>
        <FormSection {...rest} />
      </td>
    </tr>
  );
};

FormTableSection.defaultProps = {
  children: null,
  columns: 1,
  title: '',
};

FormTableSection.propTypes = {
  children: PropTypes.node,
  columns: PropTypes.number,
  title: PropTypes.string,
};

export default FormTableSection;
